import React from 'react';
import {
  ParameterValueFragment,
  NextParameterByValueFragment,
} from '../../../graphql-types';
import ListItemButton from '../../ListItemButton';

import CheckedIcon from '../../../assets/images/checkbox-checked.png';
import UncheckedIcon from '../../../assets/images/checkbox-unchecked.png';

type ValueProps = {
  parameterValue: ParameterValueFragment & NextParameterByValueFragment;
  checked: boolean;
  onPress: () => void;
};

export default function Value({parameterValue, onPress, checked}: ValueProps) {
  return (
    <ListItemButton
      onPress={onPress}
      title={parameterValue.name}
      description={parameterValue.description}
      icon={checked ? CheckedIcon : UncheckedIcon}
      iconLeft={{uri: parameterValue.icon ?? undefined}}
    />
  );
}
